import {DoraProperty} from '../../../Decorators/Decorator';

export class RowConfig {
  @DoraProperty
  public idRow = '';

  @DoraProperty
  public hasHistorical = false;

  @DoraProperty
  public initialFixing = 0.0;
}
